import "./style.scss";
import * as React from "react";
import { Flyer, FlyerItem, FlyerPage } from "./types";
import { HeatmapImage } from "./HeatmapImage";
import { Spin } from "../../Spin";

interface HeatmapProps {
  flyer: Flyer;
  metric: string;
  items: FlyerItem[];
  pageRef?: (index: number) => (el: any) => void;
  id: string;
  flyersLoading?: boolean;
  flyerItemsLoading?: boolean;
}

interface HeatmapState {
  topValue: number;
  minValue: number;
}

const initialState: HeatmapState = {
  topValue: null,
  minValue: null
};

export class Heatmap extends React.Component<HeatmapProps, any> {
  constructor() {
    super();
    this.state = initialState;
  }

  componentWillMount() {
    if (this.props.items[0]) this.handleNewItems(this.props.items);
  }

  componentWillReceiveProps(nextProps: HeatmapProps) {
    if (nextProps.items[0]) this.handleNewItems(nextProps.items);
  }

  handleNewItems = (items: FlyerItem[]) => {
    if (items.length === 0) return this.setState(initialState);
    const metricValues = items.map(
      (item: FlyerItem) => item[this.props.metric]
    );

    /* To normalize the heatmap, we treat the third highest value as 
    the top value*/
    metricValues.sort((a: number, b: number) => b - a)
    const top = metricValues[2];
    const min = metricValues[metricValues.length - 1];
    this.setState({ items: items, topValue: top, minValue: min });
  };

  metricToRGB = (value: number) => {
    const range = this.state.topValue - this.state.minValue;
    let ratio = (value - this.state.minValue) / range;
    ratio = Math.min(ratio, 1);

    /* In HSL, red is hue=0, green is hue=120 and blue is hue=240. We
    want items with high value to be red, so we flip the ratio */
    const hue = (1 - ratio) * 240;
    return "hsla(" + hue + ", 100%, 50%, 0.45)";
  };

  /* NOTE: We can't use FlyerItem.orig_flyer_item_page_position here
  because some flyers have their pages re-ordered which messes up 
  the matching */
  itemIsOnPage = (page: FlyerPage, item: FlyerItem) => {
    return (
      page.left <= item.orig_flyer_item_coordinate_left &&
      page.right >= item.orig_flyer_item_coordinate_left
    );
  };

  createHeatmapImage = (page: FlyerPage, index: number) => {
    const items = this.props.items.filter((item: FlyerItem) =>
      this.itemIsOnPage(page, item)
    );
    const resolution = page.thumbnail_image_1000w_s3_key ? "high" : "med";
    return (
      <HeatmapImage
        key={index}
        page={page}
        items={items}
        resolution={resolution}
        metric={this.props.metric}
        gradient={this.metricToRGB}
        id={this.props.id}
        pageRef={this.props.pageRef ? this.props.pageRef(index) : null}
      />
    );
  };

  renderHeatmapPages = () => {
    if (this.props.flyer) {
      const pages = this.props.flyer.flyer_pages
      pages.sort(
        (a: FlyerPage, b: FlyerPage) => a.page - b.page
      );
      return pages.map(this.createHeatmapImage);
    }
  };

  render() {
    let containerScrollStyle =
      this.props.flyerItemsLoading || this.props.flyersLoading
        ? "hidden"
        : "scroll";
    return (
      <div
        className="heatmap-container"
        ref="heatmapContainer"
        style={{ overflowX: containerScrollStyle }}
      >
        {this.props.flyerItemsLoading || this.props.flyersLoading ? (
          <div
            className="loading-spinner"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              zIndex: 999,
              backgroundColor: "rgba(255,255,255,0.9)",
              paddingTop: "180px"
            }}
          >
            <Spin />
          </div>
        ) : (
          ""
        )}
        <div style={{ position: "absolute", width: "100%", height: "100%" }}>
          <div id={this.props.id} className="flyers">
            {this.renderHeatmapPages()}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Chart/Heatmap/component.tsx